<template>
  <div>
    <button class="btn btn-info mb-2" @click.prevent="openFamilyModal" v-if="hoso_update">
      <i class="fas fa-plus"></i> Thêm
    </button>
    <b-table
      bordered
      head-variant="dark"
      hover
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template v-slot:cell(hovaten)="data" v-if="hoso_update">
        <b-link href="#" @click.prevent="openUpdateFamilyModal(data)">{{data.value}}</b-link>
      </template>
      <template v-slot:cell(ngaysinh)="data">{{data.item.ngaysinh | moment('DD/MM/YYYY')}}</template>
      <template
        v-slot:cell(thoidiemtinhgiamtru)="data"
      >{{data.item.thoidiemtinhgiamtru | moment('DD/MM/YYYY')}}</template>
      <template v-slot:cell(phuthuoc)="data">
        <template v-if="data.item.phuthuoc">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template
        v-slot:cell(quanhe)="data"
      >{{quanhes.find(x => x.id === data.item.quanhe).pickListValue}}</template>
      <template v-slot:cell(action)="data" v-if="hoso_update">
        <!-- <button class="btn btn-info mr-2" @click="openUpdateFamilyModal(data)">
          <i class="fas fa-eye"></i>
        </button>-->
        <b-link
          class="text-danger"
          href="#"
          @click.prevent="deleteFamilyItem(data)"          
        >
          <i class="fas fa-trash"></i>
        </b-link>
        <!-- <button class="btn btn-danger" @click="deleteFamilyItem(data)">
          <i class="fas fa-trash-alt"></i>
        </button> -->
      </template>
    </b-table>
    <b-modal
      v-model="modalFamilyShow"
      header-bg-variant="info"
      header-text-variant="light"
      size="xl"      
      hide-footer
    >
      <template v-slot:modal-title>
        <div v-if="gia_dinh_item.id <= 0">Thêm thông tin gia đình</div>
        <div v-else>Cập nhật thông tin gia đình</div>
      </template>
      <b-form autocomplete="off">
        <b-form-row class="mb-3">
          <b-col cols="2">
            <label class="mr-2">Họ và tên</label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <b-form-input v-model="gia_dinh_item.hovaten" required></b-form-input>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">Quan hệ</label>
            <code>*</code>
          </b-col>
          <b-col cols="3">
            <b-form-select
              v-model="gia_dinh_item.quanhe"
              :options="quanhes"
              value-field="id"
              text-field="pickListValue"
            />
          </b-col>
          <b-col cols="1">
            <button class="btn" @click.prevent="openModal('quanhe')">
              <i class="fas fa-table"></i>
            </button>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="2">
            <label class="mr-2">Năm sinh</label>
          </b-col>
          <b-col cols="3">
            <b-form-input v-model="gia_dinh_item.namsinh" type="number"></b-form-input>
          </b-col>
          <b-col cols="1"></b-col>
          <b-col cols="2">
            <label class="mr-2">Điện thoại</label>
          </b-col>
          <b-col cols="3">
            <b-form-input v-model="gia_dinh_item.dienthoai" required></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="2">
            <label class="mr-2">Địa chỉ</label>
          </b-col>
          <b-col cols="9">
            <b-form-input v-model="gia_dinh_item.diachi" required></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="2"></b-col>
          <b-col cols="9">
            <b-form-checkbox v-model="gia_dinh_item.phuthuoc">Là người phụ thuộc</b-form-checkbox>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-3">
          <b-col cols="12" class="form-inline">
            <div style="flex-grow: 1"></div>
            <b-button class="mr-3" variant="info" @click.prevent="storeFamilyItem">
              <i class="fas fa-save mr-2"></i>Lưu
            </b-button>
            <b-button variant="secondary" @click="closeFamilyModal">
              <i class="fas fa-times mr-2"></i>Đóng
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
// import VueDatepickerLocal from "vue-datepicker-local";
// import "vue-datepicker-local/dist/vue-datepicker-local.css";
export default {
  name: "GiaDinh",
  // components: {
  //   VueDatepickerLocal,
  // },
  props: ["item", "quanhes", "quoctichs"],
  data() {
    return {
      modalFamilyShow: false,
      items: [],
      itemIdex: null,
      fields: [
        {
          key: "hovaten",
          label: "Họ và tên",
        },
        {
          key: "namsinh",
          label: "Năm sinh",
        },
        {
          key: "quanhe",
          label: "Quan hệ",
        },
        {
          key: "dienthoai",
          label: "Điện thoại",
        },
        {
          key: "diachi",
          label: "Địa chỉ",
        },
        {
          key: "phuthuoc",
          label: "Là người phụ thuộc",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],
      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },
      gia_dinh_new: {
        id: 0,
        employeeid: 0,
        hovaten: null,
        quanhe: null,
        namsinh: null,
        dienthoai: null,
        diachi: null,
        phuthuoc: null,
      },
      gia_dinh_item: {
        id: 0,
        employeeid: 0,
        hovaten: null,
        quanhe: null,
        namsinh: null,
        dienthoai: null,
        diachi: null,
        phuthuoc: null,
      },
    };
  },
  computed: {        
    hoso_update() {
      return this.$store.getters.hasPermission("hoso_update");
    },
  },
  created() {
    if (this.item != null) this.initData();
  },
  methods: {
    initData() {
      axios
        .get(`/api/employeefamily/${this.item.id}`)
        .then((response) => {
          this.items = response.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    openModal(modalType) {
      this.$emit("openModal", modalType);
    },
    openFamilyModal() {
      this.gia_dinh_item = JSON.parse(JSON.stringify(this.gia_dinh_new));
      this.gia_dinh_item.employeeid = this.item.id;
      this.modalFamilyShow = true;
    },
    openUpdateFamilyModal(data) {
      this.gia_dinh_item = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalFamilyShow = true;
    },
    closeFamilyModal() {
      this.modalFamilyShow = false;
    },
    storeFamilyItem(bvModalEvt) {
      if (
        !(this.gia_dinh_item.hovaten && this.gia_dinh_item.hovaten.length) ||
        !(this.gia_dinh_item.quanhe && this.gia_dinh_item.quanhe > 0)
      ) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.gia_dinh_item.namsinh && this.gia_dinh_item.namsinh.length) {
          this.gia_dinh_item.namsinh = parseInt(this.gia_dinh_item.namsinh);
        }
        if (this.gia_dinh_item.id <= 0) {
          axios
            .post("/api/employeefamily", this.gia_dinh_item)
            .then((res) => {
              this.modalFamilyShow = false;
              this.items.push(res.data);
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        } else {
          axios
            .put("/api/employeefamily", this.gia_dinh_item)
            .then((res) => {
              this.modalFamilyShow = false;
              this.items[this.itemIdex] = JSON.parse(
                JSON.stringify(this.gia_dinh_item)
              );
              const temp = JSON.parse(JSON.stringify(this.items));
              this.items = JSON.parse(JSON.stringify(temp));
              this.itemIdex = null;
            })
            .catch((err) => {
              this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
            });
        }
      }
    },
    deleteFamilyItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/employeefamily/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>